import React from 'react';
import DataTableWithForm from '../components/DataTableWithForm';
import { API_BASE } from '../config';

const MachineConfig = () => {
  const fetchUrl = '/zts/admin/v1.0/machine/config/';
  const createUrl = '/zts/admin/v1.0/machine/config/';
  const updateUrl = id => `/zts/admin/v1.0/machine/config/${id}/`;
  const deleteUrl = id => `/zts/admin/v1.0/machine/config/${id}/`;

  const columns = [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Name' },
    { field: 'category', label: 'Category' },
    { field: 'row', label: 'Row' },
    { field: 'column', label: 'Column' },
    { field: 'inventory_quantity', label: 'Inventory' },
    {
      field: 'image_url', label: 'Image',
      format: (val) => val ? <img src={val} alt="img" style={{ width: 50, height: 50, objectFit: 'cover' }} /> : 'No image'
    },
    { field: 'is_active', label: 'Active' }
  ];

  const formFields = [
    { name: 'code', label: 'Code' },
    { name: 'name', label: 'Name' },
    { name: 'category', label: 'Category' },
    { name: 'row', label: 'Row' },
    { name: 'column', label: 'Column' },
    { name: 'inventory_quantity', label: 'Inventory Quantity' },
    { name: 'image_url', label: 'Image URL' },
    { name: 'is_active', label: 'Active' }
  ];

  return (
    <DataTableWithForm
      title="Machine Config"
      fetchUrl={fetchUrl}
      createUrl={createUrl}
      updateUrl={updateUrl}
      deleteUrl={deleteUrl}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default MachineConfig;
